import React from "react";

const Card = ({ classes, children }) => {
    return (
        <div className={`border-2 border-solid bg-base rounded-xl ${classes}`}>
            {children}
        </div>
    );
}

export default Card;